import React from 'react';

import {
  FaFile,
  FaFileAlt,
  FaFileSignature,
  FaChartLine
} from 'react-icons/fa';

import { MdKeyboardArrowDown } from 'react-icons/md';
import { connect } from 'react-redux';

import { NavLink } from 'react-router-dom';
import {
  // UncontrolledTooltip,
  Collapse,
  Nav,
  Navbar,
  NavItem,
  NavLink as BSNavLink,
} from 'reactstrap';
import bn from '../../utils/bemnames';
import SidebarItem from './SidebarItem';
import logo from '../../assets/img/mtsweblogo.png'


const navOrders = [
  { to: '/order-create', name: 'Create Order', exact: false, Icon: FaFileSignature },
  { to: '/order-search', name: 'Search Order', exact: false, Icon: FaFileAlt }
];
const navAdmin = [
  { to: '/admin-product', name: 'Product', exact: false, Icon: FaFileSignature },
  { to: '/Vendor', name: 'Vendor', exact: false, Icon: FaFileSignature },
  { to: '/Client', name: 'Client', exact: false, Icon: FaFileSignature },
  { to: '/admin-user', name: 'User', exact: false, Icon: FaFileAlt },
  { to: '/Company', name: 'Company', exact: false, Icon: FaFileAlt }
];



const navItems = [
  { to: '/', name: 'dashboard', exact: true, Icon: FaChartLine }
];



const bem = bn.create('sidebar');

class Sidebar extends React.Component {
  state = {
    isOpenOrders: true,
    isOpenContents: true,
    isOpenPages: true,
    isOpenAdmin : false
  };

  handleClick = name => () => {
    this.setState(prevState => {
      const isOpen = prevState[`isOpen${name}`];

      return {
        [`isOpen${name}`]: !isOpen,
      };
    });
  };
 
  render() {
    return (
      <aside className={bem.b()} >
        <div  />
        <div className={bem.e('content')}>
          <Navbar>
            <NavItem className="navbar-brand d-flex">
            <img src={logo} width="150" height="75" alt=""/>
              {/* <span className="text-white">
                MTS Group
              </span> */}
            </NavItem>
          </Navbar>
          <Nav vertical>
          {navItems.map(({ to, name, exact, Icon }, index) => (
              <NavItem key={index} className={bem.e('nav-item')}>
                <BSNavLink
                  id={`navItem-${name}-${index}`}
                  className="text-uppercase"
                  tag={NavLink}
                  to={to}
                  activeClassName="active"
                  exact={exact}
                >
                  <Icon className={bem.e('nav-item-icon')} />
                  <span className="">{name}</span>
                </BSNavLink>
              </NavItem>
            ))}
            <SidebarItem Title='Order' Items={navOrders}/>
            { (this.props.session.isLoggedIn && this.props.session.session.user.role.includes('Admin')) && 
                  <SidebarItem Title='Admin' Items={navAdmin}/>}
                
          </Nav>
        </div>
      </aside>
    );
  }
}
const mapStatetoProps = state => {
  return { session: state.session }
}
var sideBar = connect(mapStatetoProps)(Sidebar)
export default sideBar;
